export default __webpack_public_path__ + "static/media/tiktok.d31a8d6a.png";